/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CursorSearchDocumentResponseDto } from '../../models/cursor-search-document-response-dto';

export interface DocumentControllerSearchCursor$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 커서
 */
  cursor?: string;

/**
 * 서비스 ID
 */
  ticketId?: string;

/**
 * 작성 상태
 */
  status?: 'PENDING' | 'COMPLETED';

/**
 * 담당 선생님
 */
  teachers?: Array<string>;

/**
 * 카테고리
 */
  categories?: Array<string>;
}

export function documentControllerSearchCursor(http: HttpClient, rootUrl: string, params: DocumentControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorSearchDocumentResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentControllerSearchCursor.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('cursor', params.cursor, {});
    rb.query('ticketId', params.ticketId, {});
    rb.query('status', params.status, {});
    rb.query('teachers', params.teachers, {});
    rb.query('categories', params.categories, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CursorSearchDocumentResponseDto>;
    })
  );
}

documentControllerSearchCursor.PATH = '/api/treatment-document/cursor';
